<sl-count-display [label]="label" [amount]="amount" />
